<template>
  <div class="d-flex mt-4 justify-content-between">
    <a-tooltip
      v-for="option in optionList"
      :key="option.name"
      :class="
        `rounded p-2 d-flex flex-column align-items-center 
        ${option.disabled ? 'noHover' : 'cp'}`
      "
      :style="{ background: option.selected ? getPrimaryColor() : '#F8FAFD', width: '100px' }"
      @click="() => !option.disabled && changeScreen(option.screen)"
    >
      <template #title>
        {{ option.disabled ? "This can’t be combined with what you’ve already added to your post." : option.description }}
      </template>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
        v-if="option.icon === 'tag' && !option.selected"
        :style="{ fill: option.disabled ? '#94A3B8' : getPrimaryColor() }"
        class="hw20 min-w-20"
      >
        <path
          d="M32 229.5V80c0-8.8 7.2-16 16-16H197.5c8.5 0 16.6 3.4 22.6 9.4l176 176c12.5 12.5 12.5 32.8 0 45.3L262.6 428.1c-12.5 12.5-32.8 12.5-45.3 0l-176-176L18.7 274.7l22.6-22.6c-6-6-9.4-14.1-9.4-22.6zm-32 0c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80V229.5zM112 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        />
      </svg>
      <font-awesome-icon
        v-else-if="option.icon"
        :style="{ color: option.disabled ? '#94A3B8' : option.selected ? '#FFFFFF' : getPrimaryColor() }"
        :icon="[option.selected ? 'fas' : 'fal', option.icon]"
        class="mb-1 font20"
      />
      <svg
        v-else-if="option.name === 'Celebration'"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        class="hw20 mb-1"
        :style="{ fill: option.disabled ? '#94A3B8' : option.selected ? '#ffffff' : getPrimaryColor() }"
      >
        <path
          v-if="option.selected"
          d="M503.5 42.3c10.1-8.6 11.4-23.7 2.8-33.8s-23.7-11.4-33.8-2.8l-10 8.5c-5.8 4.9-13.2 7.5-20.7 7.3c-42.5-1.1-78.3 31.7-80.8 74.2l-1.8 30c-1 16.6-15 29.4-31.6 29c-19.4-.5-38.2 6.1-53 18.6l-10 8.5c-10.1 8.6-11.4 23.7-2.8 33.8s23.7 11.4 33.8 2.8l10-8.5c5.8-4.9 13.2-7.5 20.7-7.3c42.5 1.1 78.3-31.7 80.8-74.2l1.8-30c1-16.6 15-29.4 31.6-29c19.4 .5 38.2-6.1 53-18.6l10-8.5zM232 0c-13.3 0-24 10.7-24 24c0 30.5-10.1 54.1-20.3 70.2c-5.1 8.1-10.2 14.2-13.8 18.2c-1.8 2-3.3 3.4-4.2 4.3c-.5 .4-.8 .7-1 .9l-.1 .1 0 0c-10.1 8.5-11.4 23.6-3 33.7c8.5 10.2 23.6 11.6 33.8 3.1L184 136c15.4 18.4 15.4 18.4 15.4 18.4l0 0 0 0 .1-.1 .2-.2 .7-.6c.5-.5 1.2-1.1 2.1-1.9c1.7-1.6 4-3.8 6.6-6.7c5.3-5.8 12.3-14.2 19.2-25.1C242.1 97.9 256 65.5 256 24c0-13.3-10.7-24-24-24zM96 32C96 14.3 81.7 0 64 0S32 14.3 32 32s14.3 32 32 32s32-14.3 32-32zM512 160c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM480 480c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM395.5 342.1l.1-.1c.2-.2 .5-.6 .9-1.1c.9-1.1 2.3-2.8 4.3-4.8c4-4.2 10-9.7 17.8-15.1c15.6-10.7 37.9-20.2 66.8-17c13.2 1.5 25-8 26.5-21.2s-8-25-21.2-26.5c-43.1-4.8-76.8 9.7-99.2 25c-11.2 7.6-19.7 15.6-25.5 21.6c-2.9 3.1-5.2 5.7-6.7 7.6c-.8 1-1.4 1.8-1.9 2.4l-.6 .8-.2 .3-.1 .1 0 0 0 0c0 0 0 0 19.5 14l-19.5-13.9c-7.7 10.8-5.2 25.8 5.6 33.5c10.7 7.7 25.7 5.2 33.4-5.5l0 0zM121.2 192.7c-10.6 2.3-19.4 9.9-23.2 20L83.1 252.5 259.5 428.9 299.2 414c10.2-3.8 17.7-12.6 20-23.2s-1-21.7-8.6-29.4l-160-160c-7.7-7.7-18.8-11-29.4-8.6zM70.8 285.4L48.2 345.6 166.4 463.8l60.2-22.6L70.8 285.4zm62.7 190.7L35.9 378.5 2 468.8c-4.4 11.8-1.5 25 7.3 33.9s22.1 11.7 33.9 7.3l90.3-33.8z"
        />
        <path
          v-else
          d="M150.6 201.4C144.6 195.3 136.4 192 127.9 192c-2.234 0-4.482 .2269-6.711 .6996c-10.62 2.312-19.37 9.844-23.19 20.03l-95.1 256c-4.406 11.75-1.531 25 7.344 33.88C15.47 508.7 23.66 512 32 512c3.781 0 7.594-.6563 11.25-2.031l255.1-96c10.19-3.812 17.72-12.56 20.03-23.19c2.281-10.62-.9683-21.72-8.656-29.41L150.6 201.4zM32 479.1l28.71-76.66l47.93 47.93L32 479.1zM141.5 438.9l-68.51-68.51l22.54-60.2l106.2 106.2L141.5 438.9zM234.6 404L107.9 277.3l19.98-53.26c.0293-.0078-.0254 0 0 0l160.1 159.1L234.6 404zM496 256h-10.88c-50.63 0-98.06 25.78-130.2 70.69c-5.125 7.219-3.469 17.19 3.719 22.34C361.5 351 364.8 352 368 352c4.969 0 9.906-2.344 13.03-6.688C407 308.9 444.1 288 485.1 288H496C504.8 288 512 280.8 512 272S504.8 256 496 256zM176 160C179.2 160 182.5 159 185.3 157C230.2 124.9 256 77.5 256 26.88V16c0-8.844-7.156-16-15.1-16c-8.844 0-16 7.156-16 16v10.88c0 40.16-20.88 78.09-57.31 104.1C159.5 136.1 157.8 146.1 162.1 153.3C166.1 157.7 171 160 176 160zM64 56c13.26 0 24-10.75 24-24c0-13.26-10.74-24-24-24c-13.25 0-23.1 10.74-23.1 24C40.01 45.25 50.75 56 64 56zM480 424c-13.25 0-24 10.74-24 24c0 13.25 10.75 24 24 24c13.26 0 24-10.75 24-24C504 434.7 493.3 424 480 424zM480 136c-13.25 0-24 10.74-24 24c0 13.25 10.75 24 24 24c13.26 0 24-10.75 24-24C504 146.7 493.3 136 480 136zM382.7 175.1c19.84-23.5 18.41-46 17.25-64.06c-1-16.12-1.75-27.75 9.781-41.44c11.47-13.59 22.81-14.62 38.5-16.03c17.88-1.625 40.09-3.656 60.03-27.28c5.719-6.75 4.844-16.84-1.906-22.53c-6.688-5.656-16.81-4.844-22.53 1.906c-11.47 13.59-22.81 14.62-38.5 16.03c-17.88 1.625-40.09 3.656-60.03 27.28c-19.84 23.5-18.41 46-17.25 64.06c1 16.12 1.75 27.75-9.781 41.44c-11.44 13.53-22.75 14.56-38.44 15.97c-17.88 1.594-40.09 3.594-60 27.22c-5.719 6.75-4.844 16.84 1.906 22.53C264.7 222.8 268.3 224 272 224c4.531 0 9.062-1.938 12.22-5.688c11.44-13.53 22.75-14.56 38.44-15.97C340.5 200.8 362.8 198.8 382.7 175.1z"
        />
      </svg>
      <span :class="`font10 ${option.disabled ? 'gray400' : option.selected ? 'font-white' : 'gray900'}`">
        {{ option.name }}
      </span>
    </a-tooltip>
  </div>
</template>

<script>
export default {
  name: "DisplayOptions",
  props: { optionList: Array, changeScreen: Function },
}
</script>

<style lang="scss" scoped>
.rounded {
  &:hover {
    background: #cbd5e1 !important;
  }
}
.noHover:hover {
  background: #f8fafd !important;
}
@media screen and (max-width: 600px) {
  .mt-4 {
    gap: 8px;
    span:nth-child(4) {
      display: none !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/createNewPost/DisplayOptions.vue